import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from '../../hooks/useToken';

const ModalRenovarPaqueteAkasiaPOS = (
    {
        idLicencia,
        setAkasiaPOSModulosPorPaquete,
        idAkasiaPOSWebPaquetes,
        CodigoPaqueteAkasiaPOS,
        DescripcionPaqueteAkasiaPOS,
        showModalRenovarPaqueteAkasiaPOS,
        setShowModalRenovarPaqueteAkasiaPOS
    }
) => {

    const [procesandoModal, setProcesandoModal] = useState(false);
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * Manda a llamar el metodo para Actualizar el Paquete
     * @param {any} e
     */
    const onSubmitActualizarPaquete = async (e) => {
        e.preventDefault();

        setProcesandoModal(true);


        const response = await fetch("/api/licencia/RenovarPaqueteAkasiaPOS/?idAkasiaPOSWebPaquetes=" + idAkasiaPOSWebPaquetes + "&vCodigoPaqueteAkasiaPOS=" + CodigoPaqueteAkasiaPOS + "&idLicencia=" + idLicencia, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {

                showSuccessToast(data["table1"][0].vMessage);
                setAkasiaPOSModulosPorPaquete(data["table2"]);


            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalRenovarPaqueteAkasiaPOS(false);
        setProcesandoModal(false);
    };


    return (

        showModalRenovarPaqueteAkasiaPOS && (
            <Modal show onHide={() => setShowModalRenovarPaqueteAkasiaPOS(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>¿Renovar paquete?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Estás seguro que deseas renovar el <strong>{DescripcionPaqueteAkasiaPOS}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalRenovarPaqueteAkasiaPOS(false)} disabled={procesandoModal}>
                        Cancelar
                    </Button>

                    {procesandoModal ? (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Procesando...
                        </Button>
                    ) : (
                        <Button variant="success" onClick={onSubmitActualizarPaquete}>
                            Renovar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        )

    )
}

ModalRenovarPaqueteAkasiaPOS.propTypes = {
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setAkasiaPOSModulosPorPaquete: PropTypes.func,
    idAkasiaPOSWebPaquetes: PropTypes.number,
    CodigoPaqueteAkasiaPOS: PropTypes.string,
    DescripcionPaqueteAkasiaPOS: PropTypes.string,
    showModalRenovarPaqueteAkasiaPOS: PropTypes.bool,
    setShowModalRenovarPaqueteAkasiaPOS: PropTypes.func
};


export default ModalRenovarPaqueteAkasiaPOS;
